import React, { useContext, useEffect, useState } from 'react';

import OtpInput from 'react-otp-input';

import { string, ValidationError } from 'yup';

import { Button, FormHelperText, Stack, styled, useMediaQuery } from '@mui/material';

import { COLORS } from '../../../../Constant/COLORS';

import ToastContext from '../../../../Context/ToastContext';

import { useFormContext } from '../FormContext';

import { TypoPoppins } from '../../../Typo';

const CodeVerification = ({ description, resendVerificationCode, ...props }) => {
  const { showToastMessage } = useContext(ToastContext);
  const { nextStep } = useFormContext();

  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState(null);
  const [isResendBtnEnabled, setIsResendBtnEnabled] = useState(false);
  const [isContinueBtnEnabled, setIsContinueBtnEnabled] = useState(true);

  useEffect(() => {
    if (!isResendBtnEnabled)
      setTimeout(() => {
        setIsResendBtnEnabled(true);
      }, 50_000);
  }, [isResendBtnEnabled, setIsResendBtnEnabled]);

  function handleChange(value) {
    setVerificationCode(value);
  }

  async function handleResendVerificationCode() {
    try {
      await resendVerificationCode();
      setIsResendBtnEnabled(false);
    } catch (error) {
      showToastMessage('Something went wrong while sending Verification Code');
    }
  }

  async function handleSubmit(event) {
    try {
      event.preventDefault();
      setIsContinueBtnEnabled(false);
      setError(null);
      await schema.validate(verificationCode);

      const response = await props.handleSubmit(verificationCode);
      if (response?.error) {
        if (response?.shouldDisplayError) setError(response.error);
        return undefined;
      }

      nextStep();
    } catch (error) {
      if (error instanceof ValidationError) {
        setError(error.message);
        return undefined;
      }
      showToastMessage('Something went wrong');
    } finally {
      setIsContinueBtnEnabled(true);
    }
  }

  return (
    <Stack
      onSubmit={handleSubmit}
      component='form'
      alignItems='center'
      gap={3}
      px={{ md: 10 }}
      pb={{ md: 20 }}>
      <TypoPoppins mt={2} color={COLORS.black2} textAlign='center'>
        {description}
      </TypoPoppins>

      <Stack alignItems='center'>
        <StyledOtpInput
          shouldAutoFocus
          isInputNum
          containerStyle={{ gap: 8 }}
          numInputs={5}
          value={verificationCode}
          onChange={handleChange}
          errorStyle={{ borderColor: '#d32f2f' }}
          hasErrored={Boolean(error)}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </Stack>

      <Button
        color='blue'
        sx={{ width: { md: '60%' }, mx: 'auto' }}
        disabled={!isContinueBtnEnabled}
        type='submit'>
        <TypoPoppins color='white' fontWeight={500}>
          Continue
        </TypoPoppins>
      </Button>

      {props.helperText && (
        <TypoPoppins color='grey.400' variant='caption' mb={-2.5}>
          {props.helperText}
        </TypoPoppins>
      )}

      <Button variant='text' disabled={!isResendBtnEnabled} onClick={handleResendVerificationCode}>
        <TypoPoppins color={COLORS.black}>Re-Send OTP</TypoPoppins>
      </Button>
    </Stack>
  );
};

const StyledOtpInput = styled(OtpInput)(({ theme }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return {
    '& > input': {
      width: `${isMobile ? '1em' : '3rem'} !important`,
      aspectRatio: '1',
      fontSize: isMobile ? '1.5em' : '2rem',
      borderRadius: 4,
      border: '1px solid rgba(0,0,0,0.3)',
    },
  };
});

const schema = string()
  .required('OTP is required to continue')
  .length(5, 'Entered OTP is incorrect');

export default CodeVerification;
